<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="查看当前设备" subheading="" />
      <div class="header-btn-box">
        <a @click="ToModifyDevice">修改</a>
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">设备名称：</div>
        <div>{{deviceName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备编号：</div>
        <div>{{deviceCode || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备厂家：</div>
        <div>{{deviceManufacturerName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备型号：</div>
        <div>{{deviceModelName || '无'}}</div>
      </div>
      <div class="form-line" v-if="application">
        <div class="line-text">设备用途：</div>
        <div v-if="application === '1'">抓拍司机</div>
        <div v-if="application === '2'">抓拍越栏</div>
        <div v-if="application === '3'">安全帽报警</div>
      </div>
      <!-- <div class="form-line" v-if="parentName">
        <div class="line-text">所属网关：</div>
        <div>{{parentName || '无'}}</div>
      </div> -->
      <!--<div class="form-line">-->
        <!--<div class="line-text">车场：</div>-->
        <!--<div>{{rentName || '无'}}</div>-->
      <!--</div>-->
      <div class="form-line">
        <div class="line-text">进出类型：</div>
        <div>{{passTypeText || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备位置：</div>
        <div>{{location || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">责任人：</div>
        <div>{{personName  || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">是否下发显示屏：</div>
        <div>{{needToShowText || '无'}}</div>
      </div>
      <div class="form-line" >
        <div class="line-text">主辅相机：</div>
        <div>{{deviceTypeText || '无'}}</div>
      </div>
      <div class="form-line" v-if="parentName">
        <div class="line-text">绑定主相机：</div>
        <div>{{parentName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">是否为场中场设备：</div>
        <div>{{innerText || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">是否混进混出设备：</div>
        <div>{{multiText || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">绑定监控设备：</div>
        <div>{{videoName || '无'}}</div>
      </div>
    </form>
  </div>
</template>

<script>
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import InputTree from "../../../components/common/inputs/input-tree";
import { api } from "../../api/ParkingService";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";

export default {
  components: {
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: "parking-device-current",
  data() {
    return {
      config: {
        breadcrumb: [
          {
            value: "智慧停车",
            name: "parking-device-management"
          },
          {
            value: "设备管理"
          }
        ]
      },
      deviceName: "",
      deviceCode: "",
      parentName: "",
      deviceManufacturerName: "",
      deviceModelName: "",
      rentName: "",
      passTypeText: "",
      responsiblePerson: "",
      location: "",
      needToShowText: "",
      deviceTypeText: "",
      application: "",
      innerText: "",
      multiText:"",
      videoName: '',
      inner:"",
      personName:''
    };
  },
  created() {
    this.deviceCode = this.$route.params.id;
    this.getParkingDeviceByCode();
  },
  methods: {
    getParkingDeviceByCode() {
      this.$axios
        .get(`${api.getParkingDeviceByCode}/${this.deviceCode}`, {})
        .then(res => {
          let data = res.data.data;
          if (data.passType === "1") {
            this.passTypeText = "进";
          } else if (data.passType === "2") {
            this.passTypeText = "出";
          } else if (data.passType === "3") {
            this.passTypeText = "进/出";
          }
          if (data.needToShow == "0") {
            this.needToShowText = "不显示";
          } else {
            this.needToShowText = "显示";
          }
          if (data.deviceType == "1") {
            this.deviceTypeText = "主相机";
          } else {
            this.deviceTypeText = "辅相机";
          }
          if (data.inner) {
            this.innerText = "是";
          } else {
            this.innerText = "否";
          }
          if (data.multi) {
            this.multiText = "是";
          } else {
            this.multiText = "否";
          }
          this.deviceName = data.name;
          this.rentName = data.rentName;
          this.parentName = data.parentName;
          this.deviceManufacturerName = data.parkingDeviceManufacturerName;
          this.deviceModelName = data.parkingDeviceModelName;
          this.location = data.location;
          this.videoName = data.videoName
          this.personName=data.personName
        })
        .catch(errorHandler("获取设备数据失败"));
    },
    strategyCenter() {
      this.$router.push({
        name: "parking-device-management"
      });
    },
    ToModifyDevice() {
      this.$router.push({
        path: "/park_server/parking_device_modify/" + this.$route.params.id
      });
    }
  }
};
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a {
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover {
  color: #00a0e6;
}
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.form-line {
  margin: 30px 0;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 150px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingDevice/ParkingDeviceCurrent.vue